import React from "react";

interface VantagePointProps {
  position: [x: number, y: number, z: number];
  floor: number;
  color: number,
}
export const VantagePoint: React.FC<VantagePointProps> = ({
  position,
  floor,
  color,
}) => {
  let lineHeight = position[1] - floor;
  return (
    <>
      <mesh position={position}>
        <sphereBufferGeometry args={[0.1, 32, 32]} />
        <meshBasicMaterial color={color} />
      </mesh>
      <mesh position={[position[0], floor + lineHeight / 2, position[2]]}>
        <cylinderBufferGeometry args={[0.01, 0.01, lineHeight, 32]} />
        <meshBasicMaterial color={color} />
      </mesh>
    </>
  );
};
